import { render, staticRenderFns } from "./Email2FA.vue?vue&type=template&id=33ae86da&"
import script from "./Email2FA.vue?vue&type=script&lang=js&"
export * from "./Email2FA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33ae86da')) {
      api.createRecord('33ae86da', component.options)
    } else {
      api.reload('33ae86da', component.options)
    }
    module.hot.accept("./Email2FA.vue?vue&type=template&id=33ae86da&", function () {
      api.rerender('33ae86da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Auth/2FA/Email2FA.vue"
export default component.exports